(function () {
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  // Menú: cajón bajo el encabezado
  var t = document.querySelector('[data-menu-toggle]'), m = document.querySelector('[data-menu]');
  if (t && m) t.addEventListener('click', function () {
    m.hidden = !m.hidden; t.setAttribute('aria-expanded', String(!m.hidden));
  });

  // Pestañas "Cómo funciona / Qué incluye": abren y cierran su panel
  $$('[data-tabs]').forEach(function (box) {
    var btns = $$('[data-tab]', box);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        btns.forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          var p = document.getElementById(o.getAttribute('data-tab')); if (p) p.hidden = true;
        });
        if (!open) {
          b.setAttribute('aria-expanded', 'true');
          var p = document.getElementById(b.getAttribute('data-tab')); if (p) p.hidden = false;
        }
      });
    });
  });

  // Variante elegida (kit, selector o fija): actualiza tarjetas, precio del botón, cuotas y barra fija.
  // Los bloques viven fuera del <form> y se conectan con form="", por eso se leen con form.elements.
  function clp(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CL'); }
  $$('[data-buy]').forEach(function (form) {
    var scope = form.closest('[data-section]') || document;
    function selected() {
      var els = Array.prototype.slice.call(form.elements), pick = null;
      els.forEach(function (el) {
        if (el.name !== 'id') return;
        if (el.type === 'radio') { if (el.checked) pick = el; }
        else if (el.tagName === 'SELECT') { pick = el.options[el.selectedIndex]; }
        else if (!pick) { pick = el; }
      });
      return pick;
    }
    function sync() {
      var sel = selected();
      $$('.kit', scope).forEach(function (k) { var r = k.querySelector('input'); k.classList.toggle('is-on', !!(r && r.checked)); });
      if (!sel) return;
      var price = sel.getAttribute('data-price'), cents = parseInt(sel.getAttribute('data-cents'), 10);
      if (price) {
        $$('[data-btn-price]', scope).forEach(function (el) { el.textContent = price; });
        $$('[data-sticky-price]').forEach(function (el) { el.textContent = price; });
      }
      if (!isNaN(cents)) $$('[data-cuota]', scope).forEach(function (el) {
        var n = parseInt(el.getAttribute('data-cuota'), 10); if (n > 1) el.textContent = clp(cents / n);
      });
    }
    scope.addEventListener('change', function (e) { if (e.target.form === form || e.target.getAttribute('form') === form.id) sync(); });
    sync();
  });

  // Galería: miniaturas y deslizamiento
  $$('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('.gal__main'), thumbs = $$('.gal__thumb', g);
    if (!track) return;
    var slides = track.children;
    thumbs.forEach(function (b, n) {
      b.addEventListener('click', function () {
        track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
    function mark() {
      var n = Math.round(track.scrollLeft / (track.clientWidth || 1));
      thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === n); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
  });

  // Antes y después: deslizador y pestañas de casos
  $$('[data-ba]').forEach(function (c) {
    var r = c.querySelector('[data-ba-range]');
    if (r) r.addEventListener('input', function () { c.style.setProperty('--pos', r.value + '%'); });
  });
  $$('.ba').forEach(function (sec) {
    var tabs = $$('[data-ba-tab]', sec), pairs = $$('[data-ba-pair]', sec);
    tabs.forEach(function (tb) {
      tb.addEventListener('click', function () {
        var n = tb.getAttribute('data-ba-tab');
        tabs.forEach(function (o) { o.classList.toggle('is-on', o === tb); });
        pairs.forEach(function (p) { p.hidden = p.getAttribute('data-ba-pair') !== n; });
      });
    });
  });

  // Reseñas: paginación simple
  $$('[data-paged]').forEach(function (list) {
    var per = parseInt(list.getAttribute('data-paged'), 10) || 6;
    var items = $$('.rev__item', list), pages = Math.ceil(items.length / per), cur = 0;
    var pager = list.parentNode.querySelector('[data-pager]');
    if (!pager || pages < 2) return;
    pager.hidden = false;
    var lab = pager.querySelector('[data-page]'), prev = pager.querySelector('[data-prev]'), next = pager.querySelector('[data-next]');
    function show() {
      items.forEach(function (it, i) { it.hidden = Math.floor(i / per) !== cur; });
      lab.textContent = (cur + 1) + ' / ' + pages; prev.disabled = cur === 0; next.disabled = cur === pages - 1;
    }
    prev.addEventListener('click', function () { if (cur > 0) { cur--; show(); } });
    next.addEventListener('click', function () { if (cur < pages - 1) { cur++; show(); } });
    show();
  });

  // Barra fija en móvil cuando el botón principal sale de pantalla
  var sticky = document.querySelector('[data-sticky]');
  var mainBtn = document.querySelector('.pdp .btn--buy[name="add"]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var footer = document.querySelector('.ftr'), past = false, nearFooter = false;
    function upd() { sticky.classList.toggle('is-on', past && !nearFooter && window.innerWidth < 990); }
    new IntersectionObserver(function (e) { past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; upd(); }).observe(mainBtn);
    if (footer) new IntersectionObserver(function (e) { nearFooter = e[0].isIntersecting; upd(); }).observe(footer);
    window.addEventListener('resize', upd);
  }
})();
